<div class="route-info-container"
  [class.no-shadow]="noShadow"
  [class.user-history]="isUserHistory">

  <div class="buses-details">
    <div class="route-info-header">
      <div class="header-container">
        <div class="airline-image">
          <div class="img">
            <img loading="lazy" [src]="companyCode | busCompanyImage">
          </div>
        </div>
        <div class="airline-name">
          <span>{{companyCode | busCompanyName | async}}</span>
        </div>
        <div class="bus-data">
          <span>
            {{ 'BUS_RESULTS_MODULE.ITINERARY_LIST_SECTION.BUS' | transloco: { bus: number } }}
          </span>
        </div>
      </div>
    </div>
    <div class="start-route">
      <div>{{'BOOKING_MODULE.FLIGHT_TRIP.DEPARTURE' | transloco}}</div>
      <div class="date-time">
        <span class="date">{{ departureDate | date: 'EE, d MMM' | dateFormat }}</span>
        <span class="time">{{ departureDate | date: 'HH:mm' }}</span>
      </div>
      <div class="country-data">
        <ng-container *ngTemplateOutlet="countryDataBusDeparture"></ng-container>
      </div>
    </div>
    <div class="route-time">
      <div class="timeline-container">
        <div class="time-line">
          <div class="circle start"></div>
          <div class="circle end"></div>
        </div>
      </div>
      <div class="bus-class">
        {{ 'USER_HISTORY_MODULE.BUS' | transloco:{ bus: bus } }}
      </div>
    </div>
    <div class="end-route">
      <div>{{'BOOKING_MODULE.FLIGHT_TRIP.ARRIVAL' | transloco}}</div>
      <div class="date-time">
        <span class="date">{{ arrivalDate | date: 'EE, d MMM' | dateFormat }}</span>
        <span class="time">{{ arrivalDate | date: 'HH:mm' }}</span>
      </div>
      <div class="country-data">
        <ng-container *ngTemplateOutlet="countryDataBusArrival"></ng-container>
      </div>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="luggageTooltipContent"></ng-container>
</div>

<ng-template #countryDataBusArrival>
  <span class="terminal">{{ arrivalTerminalCity$ | async }}</span>
  <span class="country-name">{{ arrivalTerminal| terminalName | async }}</span>
</ng-template>

<ng-template #countryDataBusDeparture>
  <span class="terminal">{{departureTerminalCity$ | async}}</span>
  <span class="country-name">{{ departureTerminal| terminalName | async }}</span>
</ng-template>

<ng-template #luggageTooltipContent>
  <ng-content #luggageTooltip></ng-content>
</ng-template>
